import React, {useState, useEffect} from "react";
import { TextField, Checkbox, FormControlLabel, Grid, Typography, Box, Container, Button, FormLabel, RadioGroup, Radio, FormGroup, FormControl, FormHelperText } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import api from "./api.js";
import PdfModalViewer from "./PdfModalViewer.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp12Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const [showFormMenu, setShowFormMenu] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [sameAsInvoice, setSameAsInvoice] = useState("different");
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState({
    garbage: false,
    oil: false,
    clean: false,
  });
  const [formData, setFormData] = useState({
    user_12_name: "",
    user_12_department: "",
    user_12_phone: "",
    user_12_tel: "",
    invoice_company_name: "",
    invoice_user_name: "",
    invoice_email: "",
    invoice_address: "",
    invoice_zip: "",
    invoice_tel: "",
    invoice_fax: "",
    garbage_plan: [],
    lubricating_oil: false,
    waste_oil: false,
    cleanup: 0,
    alfa_text: "",
  });

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };


  const updateCorporateStatus = (exhibitorId, formType, action) => {
    setExhibitors((prev) =>
      prev.map((ex) => {
        if (ex.exhibitor_id !== exhibitorId) return ex;

        if (action === 'confirm') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '確認済',
            [`${formType}_host_status`]: '確認済',
          };
        }

        if (action === 'correction') {
          return {
            ...ex,
            [`${formType}_corporate_status`]: '未確認',
            [`${formType}_host_status`]: '未確認',
            [`${formType}_exhibitor_status`]: '再提出',
          };
        }

        return ex;
      })
    );
  };

  const handleCorrection = async () => {
    try {
      const res = await api.patch('/api/forms/correction', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'correction');

      alert('再提出に更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('再提出処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "corporate"
      });

      updateCorporateStatus(exhibitorId, selectedFormKey,'confirm');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "corporate"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");
  // チェックボックス変更ハンドラ
  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;

    setChecked((prev) => ({ ...prev, [name]: checked }));

    // 対応する中身もリセット
    if (!checked) {
      setFormData((prev) => ({
        ...prev,
        ...(name === "garbage" && { garbage_plan: [] }),
        ...(name === "oil" && { lubricating_oil: null, waste_oil: null }),
        ...(name === "clean" && { cleanup: null }),
      }));
    }
  };


  const handleChange = (e) => {
    const { name, value, type } = e.target;
    const val = type === "number" ? Number(value) : value;
    setFormData(prev => ({ ...prev, [name]: val }));
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const [invFieldsDisabled, setInvFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_12_name: mypageData.user_name || "",
        user_12_department: mypageData.department || "",
        user_12_phone: mypageData.phone_number || "",
        user_12_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_12_name: "",
        user_12_department: "",
        user_12_phone: "",
        user_12_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  const handleSameAsInvoice = (value) => {
    setSameAsInvoice(value);

    if (value === "same") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: mypageData.company_name || "",
        invoice_user_name: mypageData.user_name || "",
        invoice_email: mypageData.email || "",
        invoice_address: mypageData.address || "",
        invoice_zip: mypageData.zip_code || "",
        invoice_tel: mypageData.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } else if (value === "different") {
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: "",
        invoice_user_name: "",
        invoice_email: "",
        invoice_address: "",
        invoice_zip: "",
        invoice_tel: "",
      }));
      setInvFieldsDisabled(false);
    }
  };

  const handleParentInvoiceClick = async () => {
    setLoading(true);
    try {
      const res = await api.get(`/api/parent-invoice/${mypageData.representative_id}`);
      const data = res.data;
      setFormData((prev) => ({
        ...prev,
        invoice_company_name: data.company_name || "",
        invoice_user_name: data.user_name || "",
        invoice_email: data.email || "",
        invoice_address: data.address || "",
        invoice_zip: data.zip_code || "",
        invoice_tel: data.phone_number || "",
      }));
      setInvFieldsDisabled(true);
    } catch (error) {
      console.error("親出展者の請求情報取得に失敗しました:", error);
      alert("親出展者の情報を取得できませんでした。");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const fetchO12InitialData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem("user"));

        // 並列で2つAPI叩く
        const [resStatus, resO12, resMypage] = await Promise.all([
          api.get(`/api/submission-status/${exhibitorId}`),
          api.get(`/api/o12submission/${exhibitorId}`),
          api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o12Status = resStatus.data?.o12_status || "";
        const o12Data = resO12.data || {};
        const mypage = resMypage.data || {};

        if (o12Status === "申請しない") {
          setNotApply(true);
          setFormData({
            user_12_name: null,
            user_12_department: null,
            user_12_phone: null,
            user_12_tel: null,
            invoice_company_name: null,
            invoice_user_name: null,
            invoice_email: null,
            invoice_address: null,
            invoice_zip: null,
            invoice_tel: null,
            invoice_fax: null,
            garbage_plan: null,
            lubricating_oil: null,
            waste_oil: null,
            cleanup: null,
            alfa_text: null,
          });
        } else {
          if (Object.values(o12Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
          })) {
            setFormData(prev => ({
              ...prev,
              ...o12Data,
            }));
            if (
              o12Data.user_12_name === mypage.user_name &&
              o12Data.user_12_department === mypage.department &&
              o12Data.user_12_phone === mypage.phone_number &&
              o12Data.user_12_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            if (
                o12Data.invoice_company_name === mypage.company_name &&
                o12Data.invoice_user_name === mypage.user_name &&
                o12Data.invoice_email === mypage.email &&
                o12Data.invoice_address === mypage.address &&
                o12Data.invoice_tel === mypage.phone_number &&
                o12Data.invoice_zip === mypage.zip_code
            ) {
                setSameAsInvoice("same");
                setInvFieldsDisabled(true);
            } else {
                setInvFieldsDisabled(false);
            }
            const hasGarbage = o12Data.garbage_plan;
            const hasOil = o12Data.lubricating_oil || o12Data.waste_oil;
            const hasClean = o12Data.cleanup;

            setChecked({
            garbage: !!hasGarbage,
            oil: !!hasOil,
            clean: !!hasClean,
            });
          }
          setNotApply(false);
        }

      } catch (err) {
        console.error("O12初期データ取得エラー:", err);
      }
    };

    fetchO12InitialData();
  }, []);

  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_12_name: "",
            user_12_department: "",
            user_12_phone: "",
            user_12_tel: "",
            invoice_company_name: "",
            invoice_user_name: "",
            invoice_email: "",
            invoice_address: "",
            invoice_zip: "",
            invoice_tel: "",
            invoice_fax: "",
            garbage_plan: null,
            lubricating_oil: null,
            waste_oil: null,
            cleanup: null,
            alfa_text: null,
          });
      }
  };

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/');
  };
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展概要(規定)', path: '/しんきんビジネスフェア2026出展概要_0709.pdf' },
      { label: '会場平面図', path: '/会場平面図.pdf' },
      { label: '荷物の発送について', path: '/荷物の発送について.pdf' },
      { label: 'お弁当について', path: '/お弁当について.pdf' },
      { label: '宿泊のご案内', path: '/宿泊のご案内.pdf' },
      { label: '来場者カード一覧', path: '/来場者カード一覧.pdf' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者申請システムログイン方法', path: '/出展社申請システムログイン方法.pdf' },
      // { label: '各種届出提出方法', path: '/各種届出提出方法.pdf' },
      // { label: '出展者証について', path: '/出展者証について.pdf' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const [submitErrors, setSubmitErrors] = useState({});

    const handleSubmit = async () => {
    try {
        if (!exhibitorId || typeof exhibitorId !== "number") {
        alert("exhibitorId が不正です");
        return;
        }

        const submitErrors = {};

        if (!notApply) {
          // 基本必須項目チェック
          if (!formData.user_12_name?.trim()) submitErrors.user_12_name = "入力してください";
          if (!formData.user_12_phone?.trim()) submitErrors.user_12_phone = "入力してください";
          if (!formData.user_12_tel?.trim()) submitErrors.user_12_tel = "入力してください";
          if (!formData.invoice_company_name) submitErrors.invoice_company_name = "入力してください";
          if (!formData.invoice_user_name) submitErrors.invoice_user_name = "入力してください";
          if (!formData.invoice_email) submitErrors.invoice_email = "入力してください";
          if (!formData.invoice_address) submitErrors.invoice_address = "入力してください";
          if (!formData.invoice_zip) submitErrors.invoice_zip = "入力してください";
          if (!formData.invoice_tel) submitErrors.invoice_tel = "入力してください";

          // checkedのいずれかがtrueであることをチェック
          if (!checked.garbage && !checked.oil && !checked.clean) {
            submitErrors.checked = "いずれかのプランにチェックしてください";
          }

          if (checked.garbage) {
            if (!formData.garbage_plan || formData.garbage_plan.length === 0) {
              submitErrors.garbage_plan = "いずれかのゴミ処理を選択してください";
            } else {
              // 選択済みでも数値が空ならエラー
              formData.garbage_plan.forEach((g) => {
                const amountStr = g.amount?.toString() || "";
                if (!amountStr.trim()) {
                  submitErrors[`garbage_plan_${g.type}`] = "数量を入力してください";
                }
              });
            }
          }

          // 廃油処理
          if (checked.oil) {
            if (!formData.lubricating_oil && !formData.waste_oil) {
              submitErrors.oil_plan = "少なくともどちらかを希望してください";
            }
          }
          // 小間内清掃
          if (checked.clean) {
            if (!formData.cleanup || formData.cleanup <= 0) {
              submitErrors.cleanup = "小間数を正しく入力してください";
            }
          }
        }

        const fieldDisplayNames = {
          user_12_name: "担当者名",
          user_12_department: "担当部署",
          user_12_phone: "担当者携帯",
          user_12_tel: "担当者電話",
          invoice_company_name: "請求先会社名",
          invoice_user_name: "請求先担当者名",
          invoice_email: "請求先メールアドレス",
          invoice_address: "請求先住所",
          invoice_zip: "請求先郵便番号",
          invoice_tel: "請求先電話番号",
          checked: "希望プラン",
          garbage_plan: "ゴミ処理",
          oil_plan: "廃油処理",
          cleanup: "小間内清掃",
        };

        // エラーあれば早期リターン
        if (Object.keys(submitErrors).length > 0) {
          setSubmitErrors(submitErrors);
          window.scrollTo({ top: 0, behavior: "smooth" });

          const errorMessages = Object.entries(submitErrors)
            .map(([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`)
            .join("\n");

          alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
          return;
        }

        const payload = {
            exhibitor_id: exhibitorId,
            formData: formData,
            notApply: notApply,
        };

        const res = await api.post("/api/submit-o12", payload);

        if (res.status === 200) {
        alert("保存成功");
      } else {
        alert("保存失敗");
      }
      setTimeout(() => {
        if (isModal) {
          setFormModalOpen(false);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }, 1000);
        } catch (err) {
        console.error(err);
        alert("エラー");
        }
    };

    useConfirmBackLogout(navigate);
    useNavigationHistory();

  const user = JSON.parse(localStorage.getItem("user"));
  const [open , setOpen] = useState(false);
  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="しんきんビジネスマッチング　ビジネスフェア2026 小間内清掃申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #00121BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#00121bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://shinkin-tokai.sakura.ne.jp/files/polisy.pdf', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Box sx={{ position: 'fixed', width: '14%' }}>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{ width: {xs:'100%',md: '80%'}, mt:4, pb:'30px' }}>
        <Typography variant="h6">ゴミ・廃材・廃油処理と小間内清掃申込</Typography>
        <FormGroup sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_12_name" value={formData.user_12_name} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_12_name} helperText={submitErrors.user_12_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_12_department" value={formData.user_12_department} disabled={fieldsDisabled} onChange={handleChange} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_12_phone" value={formData.user_12_phone} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_12_phone} helperText={submitErrors.user_12_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_12_tel" value={formData.user_12_tel} disabled={fieldsDisabled} onChange={handleChange} error={!!submitErrors.user_12_tel} helperText={submitErrors.user_12_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>

                <Typography variant="h6" gutterBottom>
                請求先情報
                </Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsInvoice} onChange={(e) => handleSameAsInvoice(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                {user?.co_exhibit && sameAsInvoice === "different" && (
                  <Button
                    variant="outlined"
                    onClick={handleParentInvoiceClick}
                    disabled={loading}
                    style={{ marginBottom: "16px" }}
                  >
                    親出展者に請求する
                  </Button>
                )}
                </FormControl>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求先会社名" value={formData.invoice_company_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_company_name: e.target.value })} error={!!submitErrors.invoice_company_name} helperText={submitErrors.invoice_company_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={{ xs: 12, sm: 6 }}><TextField fullWidth label="請求担当者名" value={formData.invoice_user_name} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_user_name: e.target.value })} error={!!submitErrors.invoice_user_name} helperText={submitErrors.invoice_user_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先メールアドレス" value={formData.invoice_email} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_email: e.target.value })} error={!!submitErrors.invoice_email} helperText={submitErrors.invoice_email} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}} /></Grid>
                    <Grid size={6}><TextField fullWidth label="郵便番号" value={formData.invoice_zip} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_zip: e.target.value })} error={!!submitErrors.invoice_zip} helperText={submitErrors.invoice_zip} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="請求先住所" value={formData.invoice_address} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_address: e.target.value })} error={!!submitErrors.invoice_address} helperText={submitErrors.invoice_address} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={6}><TextField fullWidth label="電話番号" value={formData.invoice_tel} disabled={invFieldsDisabled} onChange={(e) => setFormData({ ...formData, invoice_tel: e.target.value })} error={!!submitErrors.invoice_tel} helperText={submitErrors.invoice_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                    <Grid size={12}><TextField fullWidth label="FAX番号" value={formData.invoice_fax} onChange={(e) => setFormData({ ...formData, invoice_fax: e.target.value })} /></Grid>
                </Grid>

                <Typography variant="h6" gutterBottom>
                ゴミ・廃材・廃油処理・小間内清掃
                </Typography>
                <Box>
                    <Button variant="outlined" onClick={() => setOpen(true)}>各種ゴミ処理・清掃金額を表示する</Button>
                </Box>
                <PdfModalViewer
                    filePath="/しんきんビジネスフェア2025-出展の手引き.pdf"
                    isOpen={open}
                    onClose={() => setOpen(false)}
                    startPage={42}
                    endPage={42}
                />
                <FormControl
                  required
                  error={!!submitErrors.garbage}   // エラー状態をここで反映
                  component="fieldset"
                  variant="standard"
                >
                  <FormGroup row>
                      <FormControlLabel
                      control={<Checkbox name="garbage" checked={checked.garbage} onChange={handleCheckboxChange} />}
                      label="ゴミ処理を希望する"
                      />
                      <FormControlLabel
                      control={<Checkbox name="oil" checked={checked.oil} onChange={handleCheckboxChange} />}
                      label="廃油処理を希望する"
                      />
                      <FormControlLabel
                      control={<Checkbox name="clean" checked={checked.clean} onChange={handleCheckboxChange} />}
                      label="小間内清掃を希望する"
                      />
                  </FormGroup>
                </FormControl>

                {checked.garbage && (
                <>
                  <Typography variant="subtitle1">ゴミ処理</Typography>
                  {[
                    { label: "A45L袋ゴミ", value: "A" },
                    { label: "B木材系", value: "B" },
                    { label: "Cプラスチック系", value: "C" },
                    { label: "D鉄くず系", value: "D" },
                    { label: "E鉄・プラスチック・木屑など混合物", value: "E" },
                    { label: "F陶器・タイル類", value: "F" },
                    { label: "G土類", value: "G" },
                  ].map((item) => {
                    // 選択されてるかどうか
                    const selected = formData.garbage_plan?.find((g) => g.type === item.value);

                    return (
                      <Box key={item.value} display="flex" alignItems="center" mb={1}>
                        <FormControl
                          required
                          error={!!submitErrors.garbage_plan}   // エラー状態をここで反映
                          component="fieldset"
                          variant="standard"
                        >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!selected}
                              onChange={(e) => {
                                let newPlan = [...(formData.garbage_plan || [])];
                                if (e.target.checked) {
                                  newPlan.push({ type: item.value, amount: "" });
                                } else {
                                  newPlan = newPlan.filter((g) => g.type !== item.value);
                                }
                                setFormData({ ...formData, garbage_plan: newPlan });
                              }}
                            />
                          }
                          label={item.label}
                        />
                        <FormHelperText sx={{color:"red"}}>
                          {submitErrors.garbage_plan}
                        </FormHelperText>
                        </FormControl>
                        {selected && (
                          <TextField
                            size="small"
                            placeholder={item.value === "A" ? "袋" : "㎥"}
                            value={selected.amount}
                            Number
                            onChange={(e) => {
                              const newPlan = formData.garbage_plan.map((g) =>
                                g.type === item.value ? { ...g, amount: e.target.value } : g
                              );
                              setFormData({ ...formData, garbage_plan: newPlan });
                            }}
                          />
                        )}
                      </Box>
                    );
                  })}
                </>
              )}


                {checked.oil && (
                  <>
                    <Typography variant="subtitle1">廃油処理</Typography>

                    <FormControl component="fieldset">
                      <FormLabel component="legend">引取り作業</FormLabel>

                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!formData.lubricating_oil}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  lubricating_oil: e.target.checked,
                                })
                              }
                            />
                          }
                          label="潤滑油引取り作業"
                        />

                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={!!formData.waste_oil}
                              onChange={(e) =>
                                setFormData({
                                  ...formData,
                                  waste_oil: e.target.checked,
                                })
                              }
                            />
                          }
                          label="廃油引取り作業"
                        />
                      </FormGroup>
                    </FormControl>
                  </>
                )}

                {checked.clean && (
                  <>
                    <Typography variant="subtitle1">小間内清掃</Typography>
                    <Typography color="error">※小間数×3日間のご請求となります。</Typography>
                    <TextField
                    type="number"
                    label="小間数"
                    value={formData.cleanup / (1430 * 3) || 0}
                    onChange={(e) => {
                        const koma = parseInt(e.target.value) || 0;
                        const price = koma * 1430 * 3;
                        setFormData({
                        ...formData,
                        cleanup: price,
                        });
                    }}
                    InputProps={{ inputProps: { min: 0 } }}
                    error={!!submitErrors.cleanup}
                    helperText={submitErrors.cleanup}
                    slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}
                    />
                    <Typography sx={{ mt: 1 }}>
                    清掃料金：{formData.cleanup} 円（税込）（1430円×小間数×3日間で計算しています。）
                    </Typography>
                  </>
                )}

                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※ゴミ・廃材・廃油処理と小間内清掃申込について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={12} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            )}
        </FormGroup>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
            <Typography>
              【上記入力内容についてのお問い合わせ先】<br />
              ●ゴミ処理・小間内清掃に関するお問い合わせ<br />
              (有) ワッツ<br />
              担当：渡瀬<br />
              TEL:052-793-8494<br />
              ●廃油・廃棄物処理に関するお問い合わせ<br />
              (株) アースクリーンシステムズ<br />
              担当：牧<br />
              TEL:052-509-4323<br />
              入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
              ※お急ぎの場合はお電話にてお問い合わせください。
            </Typography>
          </Box>
        </Container>
      </Container>
      {!isCorpModal &&(
        <>
        <Container sx={{textAlign: 'center'}}>
            <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                提出する
            </Button>
        </Container>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button
          variant="contained"
          onClick={handleCorrection}
          sx={{
            backgroundColor: "red",
            color: "white",
            "&:hover": {
              backgroundColor: "darkred",
            },
          }}
        >
          再提出
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          完了
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default Comp12Sub;